import '../../cricket/choose_captain/index_web.css';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteLocation, useLink } from 'react-router-stack';
import { showErrorToast, showToast } from '../../../actions/app-actions-types';
import {
  HeaderWithTimer,
  ScreenBackground,
  View,
  Text,
  Button,
  FlatListWrapper,
  RouteWrapper
} from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import useGame from '../../../utilities/hooks/game';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import { getPlayerName, getRouteObjByGame } from '../../../utilities/helper';
import FlatList from 'flatlist-react';
import ChooseCapPlayerRow from '../../component/choose_cap_player_row';
import Constants from '../../../constants';

interface playerTypeProps {
  data: any;
  captain?: boolean;
  viceCaptain?: boolean;
  theme: any;
}

const PlayerType = ({ data, captain, theme }: playerTypeProps) => {
  const { shortName = '' } = data;
  const playerTypeTitle = { color: theme.chooseCaptainHeaderPlayerTypeTitle };
  return (
    <View className={'choose-captain-player-type-container'}>
      <Text className={'choose-captain-player-type-name'} style={playerTypeTitle}>
        {shortName.length > 0 ? `${getPlayerName(shortName)}` : 'Select'}
      </Text>
      <View style={{ flexDirection: 'row' }}>
        <Text className={'choose-captain-player-type-captain'} style={playerTypeTitle}>
          {captain ? 'Captain' : 'Vice Captain'}
        </Text>
        <Text
          className={'choose-captain-player-type-captain'}
          style={{
            ...playerTypeTitle,
            fontFamily: 'ProximaNova-Bold'
          }}>
          &nbsp;{captain ? '| 2x Points' : '| 1.5x Points'}
        </Text>
      </View>
    </View>
  );
};

interface headerProps {
  captain: any;
  viceCaptain: any;
  theme: any;
}

const Header = ({ captain, viceCaptain, theme }: headerProps) => {
  const headerContainerColor = {
    backgroundColor: theme.chooseCaptainHeaderContainer
  };
  const separator = {
    backgroundColor: theme.chooseCaptainHeaderSeparator
  };
  return (
    <View className={'choose-captain-header-container'} style={headerContainerColor}>
      <View className={'choose-captain-header-wrapper'}>
        <View className={'choose-captain-header-tab'}>
          <PlayerType data={captain} captain={true} viceCaptain={false} theme={theme} />
        </View>
        <View className={'choose-captain-header-item-separator'} style={separator} />
        <View className={'choose-captain-header-tab'}>
          <PlayerType data={viceCaptain} captain={false} viceCaptain={true} theme={theme} />
        </View>
      </View>
    </View>
  );
};

const ChooseCaptainKabaddi = () => {
  const { createTeam, fantasyMatchClick, editTeam, gameType } = useGame();
  const { FantasyTheme: theme } = useTheme();
  const navigate = useLink();
  const dispatch = useDispatch();
  const { state }: { state: any } = useRouteLocation();
  const [teamId, setTeamId] = useState('');
  const [selectedPlayer, setSelectedPlayer] = useState([] as any);
  const [captain, setCaptain] = useState('');
  const [captainData, setCaptainData] = useState({});
  const [viceCaptain, setViceCaptain] = useState('');
  const [viceCaptainData, setViceCaptainData] = useState({});
  const {
    teamData = {},
    item: matchItem = {},
    player,
    matchId,
    isClone = false,
    entryFee,
    contestId,
    isEdit,
    joinedMatch = false,
    bonusPercentage,
    isTeamSwitch = false,
    isFromCreateTeamButton = false,
    isFromMyTeam = false
  } = state;

  const { teamA, teamB } = matchItem;
  useEffect(() => {
    const { captainId = '', viceCaptainId = '', id = '' } = teamData;
    setTeamId(isClone ? '' : id);

    const players = [] as any[];
    let obj = {};
    player.forEach((item: any) => {
      if (isClone || isEdit) {
        if (item.id === viceCaptainId) {
          obj = { ...item, viceCaptain: true, captain: false };
          setViceCaptain(viceCaptainId);
          setViceCaptainData(item);
        } else if (item.id === captainId) {
          obj = { ...item, viceCaptain: false, captain: true };
          setCaptain(captainId);
          setCaptainData(item);
        } else {
          obj = { ...item, viceCaptain: false, captain: false };
        }
      } else {
        obj = { ...item, viceCaptain: false, captain: false };
      }
      players.push(obj);
    });
    setSelectedPlayer(players);
  }, []);

  const onPressContinue = () => {
    const playerData = [...selectedPlayer];
    const players: any[] = [];
    let captainId = '',
      viceCaptainId = '';
    playerData.forEach((i) => {
      players.push({
        playerId: i.id
      });
      if (i.captain) {
        captainId = i.id;
      }
      if (i.viceCaptain) {
        viceCaptainId = i.id;
      }
    });

    if (captain === '') {
      dispatch(showErrorToast(I18n.t('PleaseSelectCaptain')));
    } else if (viceCaptain === '') {
      dispatch(showErrorToast(I18n.t('PleaseSelectViceCaptain')));
    } else {
      if (isEdit) {
        editTeamAPI(players, captainId, viceCaptainId);
      } else {
        createTeamAPI(players, captainId, viceCaptainId);
      }
    }
  };

  const selectedCaptain = (i: any) => {
    let data = [...selectedPlayer];
    data.forEach((item) => {
      if (item.playerId === i.playerId) {
        item.captain = true;
        setCaptain(item.playerId);
        setCaptainData(i);
        if (item.viceCaptain) {
          item.viceCaptain = false;
          setViceCaptain('');
          setViceCaptainData({});
        }
      } else {
        item.captain = false;
      }
    });
    setSelectedPlayer(data);
  };

  const selectedViceCaptain = (i: any) => {
    const data = [...selectedPlayer];
    data.forEach((item) => {
      if (item.playerId === i.playerId) {
        item.viceCaptain = true;
        setViceCaptain(item.playerId);
        setViceCaptainData(i);
        if (item.captain) {
          item.captain = false;
          setCaptain('');
          setCaptainData({});
        }
      } else {
        item.viceCaptain = false;
      }
    });
    setSelectedPlayer(data);
  };

  const renderItemPlayers = (item: any) => {
    return (
      <ChooseCapPlayerRow
        item={item}
        selectedCaptain={selectedCaptain}
        selectedViceCaptain={selectedViceCaptain}
        teamA={teamA}
        teamB={teamB}
        gameType={gameType}
      />
    );
  };

  const createTeamErrorMessage = (error: any) => {
    if (error?.code === 11000) {
      dispatch(
        showErrorToast('A similar team already exists for this match. Please make some change.')
      );
    } else if (error?.message) {
      dispatch(showToast(error.message));
    }
  };

  const createTeamAPI = (players: any[], captainId: string, viceCaptainId: string) => {
    dispatch(
      createTeam({
        data: {
          players,
          matchId,
          captainId,
          viceCaptainId
        },
        callback: ({ error, result = {} }: { error: any; result: any }) => {
          if (!error) {
            // newTeamData-> this is used for to show latest team if we would not get from backend
            EventEmitter.emit('teamUpdate', { latestTeamData: result });
            dispatch(showToast(I18n.t('teamCreateSuccessfully')));
            dispatch(
              fantasyMatchClick({
                data: {
                  ...matchItem,
                  completed: false,
                  joined: false,
                  joinedMatch: isFromCreateTeamButton ? false : joinedMatch,
                  contestId,
                  entryFee: entryFee,
                  bonusPercentage,
                  isTeamSwitch,
                  isFromCreateTeamButton: false,
                  isFromMyTeam: false
                }
              })
            );
            if (joinedMatch && !isFromMyTeam)
              navigate.push(getRouteObjByGame(Constants.GameType.FANTASY_KABADDI)['my_teams'], {
                isFromCreateTeam: true
              });
            else navigate.go(-2);
          } else {
            createTeamErrorMessage(error);
          }
        }
      })
    );
  };

  const editTeamAPI = (players: any[], captainId: string, viceCaptainId: string) => {
    dispatch(
      editTeam({
        data: {
          players,
          teamId,
          captainId,
          viceCaptainId
        },
        callback: ({ error }: { error: any }) => {
          if (!error) {
            EventEmitter.emit('teamUpdate', {});
            dispatch(showToast(I18n.t('teamUpdatedSuccessfully')));
            dispatch(
              fantasyMatchClick({
                data: {
                  ...matchItem,
                  completed: false,
                  joined: false,
                  joinedMatch: joinedMatch,
                  contestId,
                  entryFee: entryFee,
                  bonusPercentage,
                  isTeamSwitch
                }
              })
            );
            navigate.go(-2);
          } else {
            createTeamErrorMessage(error);
          }
        }
      })
    );
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <HeaderWithTimer
          onlyTimer={false}
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          gameType={gameType}
        />
        <View className={'choose-captain-container'}>
          <Header captain={captainData} viceCaptain={viceCaptainData} theme={theme} />
          <View className={'choose-captain-container'}>
            <Text
              className={'choose-captain-vice-label'}
              style={{
                color: theme.chooseCaptainViceCaptainTitle
              }}>
              {'Choose your Captain & Vice Captain'}
            </Text>

            <View className={'choose-captain-list-container'}>
              <FlatListWrapper>
                <FlatList list={selectedPlayer} renderItem={renderItemPlayers} renderOnScroll />
              </FlatListWrapper>
              <View className={'choose-captain-bottom-card'}>
                <Button
                  onPress={onPressContinue}
                  buttonClassName={'choose-captain-button'}
                  buttonStyle={{
                    backgroundColor: theme.chooseCaptainContinueBtn,
                    shadowColor: theme.chooseCaptainContinueBtn
                  }}
                  labelClassName={'choose-captain-button-label'}
                  labelStyle={{
                    color: theme.chooseCaptainContinueBtnTitle
                  }}>
                  {I18n.t('SaveTeam')}
                </Button>
              </View>
            </View>
          </View>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default ChooseCaptainKabaddi;
